module.exports = __webpack_public_path__ + "static/media/fff-dashboard.30e59ebc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fff/fff-dashboard.png
// module id = 46
// module chunks = 0